import { ApolloClient, InMemoryCache } from '@apollo/client';
import { returnCommonVariables } from "../../commonVariables";

export const getGraphqlClient = () => {
    // console.log(returnCommonVariables()["graphQLURL"]);
    return new ApolloClient({
        uri: returnCommonVariables()["graphQLURL"],
        cache: new InMemoryCache(),
        onError: ({graphQLErrors, networkError, operation, forward}) => {
            console.log(graphQLErrors);
            console.log(networkError);
            console.log(operation);
        }
    })
}
